import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IamProviderType } from '@1po/1po-bff-fe-spec/generated/backoffice/central_settings/model/CentralCountrySettings';
import {
  getCentralSettingsRequestSaga,
  getCentralSettingsStatus,
  getCountry,
  getCountrySettings,
  getIamProvider,
  getMktpDeliveryOptions,
  isDirty,
  setCentralSettingsStatus,
  setCountry,
  setIamProvider,
  setMktpDeliveryOptions,
  updateCentralSettingsRequestSaga,
} from 'domains/centralSettings/CentralSettings.store';
import AllowMktpDeliveryOptions from 'pages/BackOfficePage/BackOfficeCategories/CentralSettings/AllowMktpDeliveryOptions';
import SelectCountry from 'pages/BackOfficePage/BackOfficeCategories/CentralSettings/SelectCountry';
import SelectOtherBrandCatalog from 'pages/BackOfficePage/BackOfficeCategories/CentralSettings/SelectOtherBrandCatalog';
import SellerManagement from 'pages/BackOfficePage/BackOfficeCategories/CentralSettings/SellerManagement/SellerManagement';
import CentralSettingsHeader from 'pages/BackOfficePage/BackOfficeCategories/CentralSettings/SettingsHeader';
import { FOUND, LOADING } from 'utils';

const CentralSettings = () => {
  const dispatch = useDispatch();
  const countrySettings = useSelector(getCountrySettings);
  const country = useSelector(getCountry);
  const iamProvider = useSelector(getIamProvider);
  const allowMktpDeliveryOptions = useSelector(getMktpDeliveryOptions);
  const centralSettingsStatus = useSelector(getCentralSettingsStatus);
  const editable = centralSettingsStatus === FOUND;
  const dirty = useSelector(isDirty);
  const saveEnabled = editable && dirty;

  useEffect(() => {
    dispatch(getCentralSettingsRequestSaga());
  }, [dispatch]);

  const handleSelectCountry = (countryKey: string) => {
    dispatch(setCountry(countryKey));
  };

  const handleSelectIamProvider = (iamProviderKey: IamProviderType) => {
    dispatch(setIamProvider(iamProviderKey));
  };

  const handleChangeMktpDeliveryOptions = (value: boolean) => {
    dispatch(setMktpDeliveryOptions(value));
  };

  const handleSave = () => {
    dispatch(setCentralSettingsStatus(LOADING));
    dispatch(updateCentralSettingsRequestSaga({ countrySettings }));
  };

  return (
    <>
      <CentralSettingsHeader onSave={handleSave} enabled={saveEnabled} />
      <SelectCountry selected={country} onSelect={handleSelectCountry} enabled={editable} />
      <SelectOtherBrandCatalog selected={iamProvider} onSelect={handleSelectIamProvider} enabled={editable} />
      <AllowMktpDeliveryOptions
        value={allowMktpDeliveryOptions}
        onChange={handleChangeMktpDeliveryOptions}
        enabled={editable}
      />
      <SellerManagement countryCode={country} />
    </>
  );
};

export default CentralSettings;
